export const GET_TECHNICAL_ANALYSIS = 'GET_TECHNICAL_ANALYSIS'
export const GET_TECHNICAL_ANALYSIS_SUCCESS = 'GET_TECHNICAL_ANALYSIS_SUCCESS'

export const UPDATE_TECHNICAL_ANALYSIS = 'UPDATE_TECHNICAL_ANALYSIS'
export const UPDATE_TECHNICAL_ANALYSIS_SUCCESS = 'UPDATE_TECHNICAL_ANALYSIS_SUCCESS'

export const GET_TECHNICAL_ANALYSIS_ERROR = 'GET_TECHNICAL_ANALYSIS_ERROR'